module.exports = __webpack_public_path__ + "img/1920_news_sub_img1.3c549e91.png";